<ng-container
  [formGroup]="DomainInputForm"
  *transloco="let t">
  <ng-container [ngSwitch]="mode">
    <!-- Select 1brd.com subdomain -->
    <label
      *ngSwitchCase="'subdomain'"
      class="form-control form-control-domain"
      [ngClass]="inputClasses">
      <input
        type="text"
        class="form-control-domain_input"
        autocapitalize="off"
        autocorrect="off"
        formControlName="domain"
        placeholder="{{ t('auth.login.domain') }}"
        (focus)="onFocus()"
        (blur)="onBlur()" />
      <span class="form-control-domain_caption">.1brd.com</span>
    </label>

    <!-- Select custom domain -->
    <label
      *ngSwitchCase="'custom-domain'"
      class="form-control form-control-domain"
      [ngClass]="inputClasses">
      <span class="form-control-domain_caption">https://</span>
      <input
        type="text"
        class="form-control-domain_input"
        autocapitalize="off"
        autocorrect="off"
        formControlName="domain"
        placeholder="{{ t('auth.login.domain-com') }}"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (paste)="onPaste($event)" />
    </label>
  </ng-container>

  <div
    class="message __error text-xsmall"
    role="alert"
    *ngIf="domain.invalid && domain.dirty">
    <ng-container *ngIf="domain.errors.required">{{ t('auth.domain-required') }}</ng-container>
    <ng-container *ngIf="domain.errors.maxlength">{{ t('auth.domain-too-long') }}</ng-container>
    <ng-container *ngIf="domain.errors.subdomain">{{ t('auth.domain-invalid') }}</ng-container>
    <ng-container *ngIf="domain.errors.domain">{{ t('auth.custom-domain-invalid') }}</ng-container>
    <ng-container *ngIf="domain.errors.startsWithDash">{{ t('auth.domain-starts-with-dash') }}</ng-container>
    <ng-container *ngIf="domain.errors.endsWithDash">{{ t('auth.domain-ends-with-dash') }}</ng-container>
    <ng-container *ngIf="domain.errors.domainNotAvailable">{{ t('auth.domain-not-available') }}</ng-container>
  </div>
</ng-container>
